<template>
  <div v-if="page_loading">
    <loading :page_loading="page_loading" />
  </div>
  <div v-else>
    <loading :loading="loading" />

    <!-- นำทาง -->
    <v-card class="v-card-bottom-30">
      <v-card-title>
        {{ use_language.oms }}
        <v-icon>mdi-chevron-right</v-icon>
        {{ use_language.user_management }}
      </v-card-title>
    </v-card>

    <!-- popup เพิ่ม/แก้ไข -->
    <v-dialog v-model="dialog" scrollable max-width="620" persistent :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card elevation="1">
        <v-card-title class="height-57">
          <span v-if="isNew">{{ use_language.add_user }}</span>
          <span v-else>{{ use_language.edit_user }}</span>
          <v-spacer/>
          <v-btn icon @click="dialog = false"><v-icon color="danger">mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider/>
        <v-card-text class="overflow-x-auto">
          <v-form ref="userForm" lazy-validation>
            <!-- เพิ่มผู้ใช้ = สร้างบัญชีใหม่เสมอ ช่องบัญชีถูกล็อกเมื่อบัญชีถูกสร้างไปแล้วแต่กำหนดสิทธิ์ไม่สำเร็จ -->
            <template v-if="isNew">
              <v-row>
                <v-col cols="12" md="3" class="pa-0">{{ use_language.staff_name }} :</v-col>
                <v-col cols="12" md="9" class="pa-0">
                  <v-text-field :value="user.name" @change="value => user.name = Trim_value(value)" :rules="rulesRequired" autocomplete="off" outlined dense></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="3" class="pa-0">{{ use_language.phone }} :</v-col>
                <v-col cols="12" md="9" class="pa-0">
                  <v-text-field :value="user.phone" @change="value => user.phone = Trim_value(value)" autocomplete="off" outlined dense></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="3" class="pa-0">{{ use_language.username }} :</v-col>
                <v-col cols="12" md="9" class="pa-0">
                  <v-text-field :value="user.username" @change="value => user.username = Trim_value(value)" :rules="rulesRequired" autocomplete="off" outlined dense></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="3" class="pa-0">{{ use_language.password }} :</v-col>
                <v-col cols="12" md="9" class="pa-0">
                  <v-text-field
                    v-model="user.password"
                    :rules="rulesRequired"
                    :type="showPassword ? 'text' : 'password'"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="showPassword = !showPassword"
                    autocomplete="new-password"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="3" class="pa-0">{{ use_language.confirm_password }} :</v-col>
                <v-col cols="12" md="9" class="pa-0">
                  <v-text-field
                    v-model="user.password2"
                    :rules="rulesPassword2"
                    :type="showPassword ? 'text' : 'password'"
                    autocomplete="new-password"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>
            </template>

            <v-row v-else>
              <v-col cols="12" md="3" class="pa-0">{{ use_language.staff }} :</v-col>
              <v-col cols="12" md="9" class="pa-0">
                <v-text-field :value="user.name + ' (' + user.username + ')'" disabled outlined dense></v-text-field>
              </v-col>
            </v-row>
            <v-row class="pt-3">
              <v-col cols="12" md="3" class="pa-0">{{ use_language.role }} :</v-col>
              <v-col cols="12" md="9" class="pa-0">
                <v-select v-model="user.role" :items="roleItems" :rules="rulesRequired" outlined dense @change="onRoleChange()"></v-select>
              </v-col>
            </v-row>
            <!-- Admin เห็นทุกช่องทางและทุก location จึงไม่ต้องเลือก -->
            <template v-if="user.role != null && user.role != 'ADMIN'">
              <v-row>
                <v-col cols="12" md="3" class="pa-0">{{ use_language.channel }} :</v-col>
                <v-col cols="12" md="9" class="pa-0">
                  <!-- ผู้อนุมัติมีได้เฉพาะช่องทาง ON -->
                  <v-select
                    v-model="user.channel"
                    :items="channelItems"
                    :disabled="user.role == 'APPROVER'"
                    :rules="rulesRequired"
                    outlined
                    dense
                    @change="user.locationIds = []"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="3" class="pa-0">{{ use_language.location }} :</v-col>
                <v-col cols="12" md="9" class="pa-0">
                  <v-autocomplete
                    v-model="user.locationIds"
                    :items="locationsOfChannel"
                    item-text="name"
                    item-value="id"
                    :rules="rulesLocation"
                    multiple
                    chips
                    small-chips
                    deletable-chips
                    outlined
                    dense
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </template>
            <v-row>
              <v-col cols="12" class="pa-0" align="right">
                <v-btn :elevation="1" color="primary" class="px-2" @click="Save()">
                  <v-icon size="20" class="mr-1">mdi-content-save</v-icon>
                  <span class="fn-14"><b> {{ use_language.record }} </b></span>
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- popup เปลี่ยนรหัสผ่าน: ของตัวเองต้องยืนยันรหัสปัจจุบัน ของผู้ใช้อื่น Admin ตั้งใหม่ได้เลย -->
    <v-dialog v-model="passwordDialog" max-width="560" persistent :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card elevation="1">
        <v-card-title class="height-57">
          <span>{{ use_language.change_password }}</span>
          <v-spacer/>
          <v-btn icon @click="passwordDialog = false"><v-icon color="danger">mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider/>
        <v-card-text>
          <oms-change-password-form
            v-if="passwordDialog"
            :target="passwordTarget"
            :is-self="passwordTarget != null && passwordTarget.staffShopID == myStaffId"
            @done="afterPasswordChanged()"
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- รายการ -->
    <v-card elevation="1" class="v-card-bottom-30">
      <v-card-title class="height-57">
        <v-icon size="22" color="success darken-3">mdi-account-multiple</v-icon><span class="ml-3">{{ use_language.user }}</span>
        <v-spacer/>
        <v-btn v-if="isAdmin" :elevation="1" color="primary" class="px-2" @click="Edit(null)">
          <v-icon size="22" class="mr-1">mdi-plus</v-icon>
          {{ use_language.add_user }}
        </v-btn>
      </v-card-title>
      <v-divider/>
      <v-card-text>
        <!-- สิทธิ์อื่นที่ไม่ใช่ Admin เห็นเฉพาะบัญชีของตัวเอง จึงไม่ต้องมีตัวกรอง -->
        <v-row v-if="isAdmin" class="pb-2">
          <v-col cols="12" md="3" class="pa-1">
            <v-select v-model="filter.channel" :items="filterChannelItems" :label="use_language.channel" outlined dense hide-details></v-select>
          </v-col>
          <v-col cols="12" md="3" class="pa-1">
            <v-select v-model="filter.role" :items="filterRoleItems" :label="use_language.role" outlined dense hide-details></v-select>
          </v-col>
          <v-col cols="12" md="6" class="pa-1">
            <v-text-field
              v-model="filter.keyword"
              :placeholder="use_language.search"
              prepend-inner-icon="mdi-magnify"
              autocomplete="off"
              outlined
              dense
              hide-details
              clearable
            ></v-text-field>
          </v-col>
        </v-row>

        <!-- PC hidden-xs-only -->
        <v-data-table
          :headers="header"
          :items="filtered"
          :items-per-page="50"
          :footer-props="{ 'items-per-page-options': [50, 100, -1] }"
          :no-data-text="use_language.no_data"
          class="packhai-border-table hidden-xs-only"
        >
          <template v-slot:item.no="{ item }">{{ filtered.indexOf(item) + 1 }}</template>
          <template v-slot:item.role="{ item }">{{ use_language['role_' + item.role] }}</template>
          <template v-slot:item.channel="{ item }">{{ item.channel == 'ALL' ? use_language.channel_ALL : item.channel }}</template>
          <template v-slot:item.locations="{ item }">
            <span v-if="item.role == 'ADMIN'">{{ use_language.all_location }}</span>
            <span v-else>{{ item.locations.map(location => location.name).join(', ') }}</span>
          </template>
          <template v-slot:item.password="{ item }">
            <a @click="OpenPassword(item)"><v-icon size="18">mdi-key-variant</v-icon></a>
          </template>
          <template v-slot:item.edit="{ item }">
            <a @click="Edit(item)"><v-icon size="18">fa-edit</v-icon></a>
          </template>
          <template v-slot:item.delete="{ item }">
            <a @click="Delete(item)"><v-icon size="18" color="red">fa-trash-alt</v-icon></a>
          </template>
        </v-data-table>

        <!-- Mobile hidden-sm-and-up -->
        <v-data-iterator
          :items="filtered"
          :items-per-page="50"
          :no-data-text="use_language.no_data"
          class="hidden-sm-and-up"
        >
          <template v-slot:default="props">
            <v-row>
              <v-col v-for="item in props.items" :key="item.staffShopID" cols="12" class="pa-1">
                <v-card>
                  <v-row class="pa-2">
                    <v-col cols="12" class="pa-0">{{ use_language.staff_name }} : {{ item.name }} ({{ item.username }})</v-col>
                    <v-col cols="12" class="pa-0">{{ use_language.role }} : {{ use_language['role_' + item.role] }}</v-col>
                    <v-col cols="12" class="pa-0">{{ use_language.channel }} : {{ item.channel == 'ALL' ? use_language.channel_ALL : item.channel }}</v-col>
                    <v-col cols="12" class="pa-0">
                      {{ use_language.location }} :
                      <span v-if="item.role == 'ADMIN'">{{ use_language.all_location }}</span>
                      <span v-else>{{ item.locations.map(location => location.name).join(', ') }}</span>
                    </v-col>
                    <v-col cols="12" class="pa-0 text-right">
                      <a @click="OpenPassword(item)"><v-icon size="18" class="mr-3">mdi-key-variant</v-icon></a>
                      <a v-if="isAdmin" @click="Edit(item)"><v-icon size="16" class="mr-3">fa-edit</v-icon></a>
                      <a v-if="isAdmin" @click="Delete(item)"><v-icon size="16" color="red">fa-trash-alt</v-icon></a>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </template>
        </v-data-iterator>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  import Swal from 'sweetalert2'
  import Loading from '@/website/components/Loading'
  import OmsChangePasswordForm from '@/website/backend/oms/components/OmsChangePasswordForm'
  import { getOmsLanguage } from '@/website/backend/oms/oms_language'
  import { Trim_value } from '@/website/global_function'
  import { getOmsContext, getUserList, saveUser, deleteUser, getLocationList, createUser } from '@/website/backend/oms/oms_service'

  export default {
    components: {
      Loading,
      OmsChangePasswordForm
    },
    data: () => ({
      // page
      page_loading: true,
      loading: false,
      use_language: getOmsLanguage(),

      filter: { channel: null, role: null, keyword: null },
      dataset: [],
      locations: [],

      // popup
      dialog: false,
      passwordDialog: false,
      passwordTarget: null,
      myStaffId: Number(localStorage.getItem('staff_id')),
      isAdmin: false,
      isNew: true,
      user: {},
      rulesRequired: [],
      rulesLocation: [],
      rulesPassword2: [],
      showPassword: false
    }),
    computed: {
      roleItems () {
        return ['ADMIN', 'CREATOR', 'APPROVER'].map(role => ({ value: role, text: this.use_language['role_' + role] }))
      },
      channelItems () {
        return [
          { value: 'ON', text: this.use_language.channel_on },
          { value: 'TT', text: this.use_language.channel_tt }
        ]
      },
      filterRoleItems () {
        return [{ value: null, text: this.use_language.all }, ...this.roleItems]
      },
      filterChannelItems () {
        return [
          { value: null, text: this.use_language.all },
          { value: 'ALL', text: this.use_language.channel_ALL },
          { value: 'ON', text: 'ON' },
          { value: 'TT', text: 'TT' }
        ]
      },
      locationsOfChannel () {
        return this.locations.filter(location => location.channel == this.user.channel)
      },
      header () {
        return [
          { text: this.use_language.no, align: 'center', sortable: false, value: 'no', width: '70px' },
          { text: this.use_language.staff_name, align: 'left', value: 'name', sortable: false },
          { text: this.use_language.username, align: 'left', value: 'username', sortable: false },
          { text: this.use_language.role, align: 'center', value: 'role', sortable: false, width: '160px' },
          { text: this.use_language.channel, align: 'center', value: 'channel', sortable: false, width: '110px' },
          { text: this.use_language.location, align: 'left', value: 'locations', sortable: false },
          { text: this.use_language.password, align: 'center', value: 'password', sortable: false, width: '90px' },
          { text: this.use_language.edit, align: 'center', value: 'edit', sortable: false, width: '80px', adminOnly: true },
          { text: this.use_language.delete, align: 'center', value: 'delete', sortable: false, width: '80px', adminOnly: true }
        ].filter(column => this.isAdmin || !column.adminOnly)
      },
      filtered () {
        const keyword = (this.filter.keyword || '').trim().toLowerCase()
        return this.dataset.filter(item =>
          (this.filter.channel == null || item.channel == this.filter.channel) &&
          (this.filter.role == null || item.role == this.filter.role) &&
          (keyword == '' ||
            (item.name || '').toLowerCase().includes(keyword) ||
            (item.username || '').toLowerCase().includes(keyword) ||
            item.locations.some(location => location.name.toLowerCase().includes(keyword)))
        )
      }
    },
    async created () {
      document.title = this.$router.history.current.meta.title
      const context = await getOmsContext()
      this.isAdmin = context.role == 'ADMIN'
      this.myStaffId = context.staffID || this.myStaffId
      const locationResponse = await getLocationList({ isActive: true })
      if (locationResponse.status == 'success') {
        this.locations = locationResponse.items
      }
      await this.Load_data()
      this.page_loading = false
    },
    methods: {
      Trim_value,
      OpenPassword (item) {
        this.passwordTarget = item
        this.passwordDialog = true
      },
      async afterPasswordChanged () {
        const isSelf = this.passwordTarget.staffShopID == this.myStaffId
        this.passwordDialog = false
        if (isSelf) {
          // การเปลี่ยนรหัสผ่านยกเลิก token เดิมทั้งหมด จึงต้องเข้าสู่ระบบใหม่
          await this.$swal({ position: 'top', type: 'success', text: this.use_language.password_changed_relogin, allowOutsideClick: false })
          localStorage.clear()
          this.$router.replace('/login')
          window.location.reload()
          return
        }
        this.$swal({ toast: true, timer: 1500, showConfirmButton: false, position: 'top', type: 'success', title: this.use_language.success })
      },
      showError (response) {
        this.$swal({
          position: 'top',
          type: 'error',
          text: response.message || (response.errorCode == 'NETWORK' ? this.use_language.network_error : this.use_language.cannot_perform_operation)
        })
      },
      async Load_data () {
        this.loading = true
        // ผู้ใช้ OMS ของ shop มีหลักร้อย จึงโหลดทั้งหมดแล้วกรองในหน้าจอ
        const response = await getUserList({ skip: 0, take: 500 })
        this.loading = false
        if (response.status == 'success') {
          this.dataset = response.items
        } else {
          this.showError(response)
        }
      },
      async Edit (item) {
        this.rulesRequired = []
        this.rulesLocation = []
        this.rulesPassword2 = []
        this.showPassword = false
        if (item != null) {
          this.isNew = false
          this.user = {
            staffShopId: item.staffShopID,
            name: item.name,
            username: item.username,
            role: item.role,
            channel: item.channel == 'ALL' ? null : item.channel,
            locationIds: item.locations.map(location => location.id)
          }
        } else {
          this.isNew = true
          this.user = {
            name: null, phone: null, username: null, password: null, password2: null,
            staffShopId: null, role: null, channel: null, locationIds: []
          }
        }
        this.dialog = true
      },
      onRoleChange () {
        if (this.user.role == 'APPROVER' && this.user.channel != 'ON') {
          this.user.channel = 'ON'
          this.user.locationIds = []
        }
      },
      async Save () {
        this.rulesRequired = [v => !!v || this.use_language.please_specify]
        this.rulesLocation = [v => (v != null && v.length > 0) || this.use_language.please_specify]
        this.rulesPassword2 = [v => v === this.user.password || this.use_language.password_mismatch]
        await this.$nextTick()
        if (!this.$refs.userForm.validate()) {
          return
        }
        this.loading = true
        const scope = {
          role: this.user.role,
          channel: this.user.role == 'ADMIN' ? 'ALL' : this.user.channel,
          locationIds: this.user.role == 'ADMIN' ? [] : this.user.locationIds
        }
        // ผู้ใช้ใหม่: สร้างบัญชีพร้อมสิทธิ์ในครั้งเดียว ถ้าไม่ผ่านจะไม่มีบัญชีค้าง
        const response = this.isNew
          ? await createUser({ name: this.user.name, phone: this.user.phone, username: this.user.username, password: this.user.password, ...scope })
          : await saveUser({ staffShopId: this.user.staffShopId, ...scope })
        this.loading = false
        if (response.status != 'success') {
          this.showError(response)
          return
        }
        await this.Load_data()
        this.$swal({ toast: true, timer: 1500, showConfirmButton: false, position: 'top', type: 'success', title: this.use_language.success })
        this.dialog = false
      },
      Delete (item) {
        Swal.fire({
          type: 'question',
          title: item.name + ' (' + item.username + ')',
          text: this.use_language.confirm_delete_user,
          confirmButtonText: this.use_language.confirm,
          cancelButtonText: this.use_language.cancel,
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          allowOutsideClick: false
        }).then(async (result) => {
          if (result.value) {
            this.loading = true
            const response = await deleteUser(item.staffShopID)
            this.loading = false
            if (response.status != 'success') {
              this.showError(response)
              return
            }
            await this.Load_data()
            this.$swal({ toast: true, timer: 1500, showConfirmButton: false, position: 'top', type: 'success', title: this.use_language.success })
          }
        })
      }
    }
  }
</script>
